import isEmpty from 'lodash/isEmpty';
import containerHasMaterial from '@/lib/containerHasMaterial';
function hasSchemeWithMaterial(property, { materials, category }) {
    return property.some((scheme) => scheme.containers.some((container) => containerHasMaterial(container, { materials, category })));
}
export default function getPropertiesByMaterial(properties = {}, { materials, category } = {}) {
    const propertyTypes = Object.keys(properties);
    const foundProperties = propertyTypes.reduce((propertiesWithMaterial, propertyType) => {
        const property = properties[propertyType];
        if (hasSchemeWithMaterial(property, { materials, category })) {
            propertiesWithMaterial[propertyType] = property;
        }
        return propertiesWithMaterial;
    }, {});
    return isEmpty(foundProperties) ? undefined : foundProperties;
}
